export function PortalFooter() {
  return (
    <footer className="border-t border-gray-200 mt-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="text-center text-sm text-gray-500 space-y-2">
          <p>
            Powered by{' '}
            <a href="https://niftee.ai" className="text-primary-600 hover:text-primary-700">
              niftee
            </a>
          </p>
          <p>
            <a
              href="https://niftee.ai/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-primary-600 transition-colors"
            >
              Terms of Service
            </a>
            {' · '}
            <a
              href="https://niftee.ai/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-primary-600 transition-colors"
            >
              Privacy Policy
            </a>
          </p>
          <p className="text-gray-400">© 2026 Profit Now Solutions LLC</p>
        </div>
      </div>
    </footer>
  );
}
